import React from 'react'

import {About,Footer,Work,Skills,Header} from './container'
import {Navbar} from './components'
import './App.scss'
import Foot from './container/Foot/Foot'



const App = () => {
  return (
    <div className='app'>
      <Navbar/>
      <Header/>
      <About/>
      <Work/>
      <Skills/>
      <Footer/>
      <Foot/>
    </div>
  )
}

export default App